import React, { useState } from "react";
// Components
import HeaderBar from "./components/HeaderBar";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
// types
import { FiltersProps } from "./types";
import { IfetchNotificationsRecipients } from "store/notificationsRecipients/initialState";
import { IfetchNotificationsStatus } from "store/notificationsStatus/initialState";

export const Filters: React.FC<FiltersProps> = ({ columns }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCloseDiv, setIsCloseDiv] = useState(false);
  const { data } = useSelector<RootState, IfetchNotificationsStatus>(
    (state) => state?.notificationStatus
  );
  // Handlers
  const handleToggleDropdown = () => {
    setIsCloseDiv((prevState) => !prevState);
  };

  return (
    <>
      <div className="flex flex-col items-start justify-start w-full gap-2">
        <HeaderBar
          data={data}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          handleToggleDropdown={handleToggleDropdown}
          isCloseDiv={isCloseDiv}
        />
      </div>
    </>
  );
};
